import { useMemo } from 'react'
import { Controller } from 'react-hook-form'
import { useShallow } from 'zustand/react/shallow'
import { useBoundStore } from '../../../state/bound.store'
import { MembersList } from '../editMembers/membersList'

interface IFormDateTimeProps {
    control: any
    name: string
}
export const FormEditMembers = ({ control, name }: IFormDateTimeProps) => {
    const { selectedItineraryUsers } = useBoundStore(
        useShallow((s) => ({
            selectedItineraryUsers: s.selectedItineraryUsers,
        }))
    )

    const itinMembers = useMemo(() => {
        return selectedItineraryUsers()
    }, [selectedItineraryUsers])

    return (
        <Controller
            name={name}
            control={control}
            render={({ field: { onChange, value }, fieldState: { error } }) => {
                const handleChange = (newValue: any) => {
                    onChange(newValue)
                }
                return (
                    <MembersList
                        users={itinMembers}
                        setSelectedUsers={handleChange}
                        selectedUsers={value ?? []}
                        allowSelfRemove={true}
                    />
                )
            }}
        />
    )
}
